/*
 * @Author: w-lichenxia-8caYS w_lichenxia@xiwang.com
 * @Date: 2024-04-30 18:31:48
 * @LastEditors: Shusheng
 * @LastEditTime: 2024-07-08 17:16:22
 * @FilePath: /teacher-desk/src/log/pages/common.ts
 * @Description: 点位记录
 */
/** 批量工具点击点位 */
export const commonLog = {
  adjustment_smallclass: 'click_60_01_02_10', // 点击 批量工具-调整小班学员
  wechat_tts: 'click_60_01_02_04', // 点击 批量工具-加微语音电话
  copy_name: 'click_60_01_02_05', // 点击 批量工具-复制姓名
  export: 'click_60_01_02_06', // 点击 批量工具-导出表格
  group_sms: 'click_60_01_02_07', // 点击 批量工具-群发短信
  generate_list: 'click_60_01_02_09', // 点击 批量工具-生成榜单
  batch_label: 'click_60_01_02_11', // 点击 批量工具-批量标注
  create_wechatclass: 'click_60_01_02_12', // 点击 批量工具-新建企微班级群
  binding_class: 'click_60_01_02_13', // 点击 批量工具-班级群绑定
  update_classmember: 'click_60_01_02_14', // 点击 批量工具-班级群成员更新
  voice_call: 'click_60_01_02_03', // 点击 批量工具-语音电话
  copy_companystu_link: 'click_60_01_02_08', // 点击 批量工具-复制伴学链接
  copy_classmark_link: 'click_60_01_02_23', // 点击 批量工具-复制课堂标记链接
  diagnostic_link: 'click_60_01_02_24', // 点击 批量工具-复制诊断链接
  sch_voice_call: 'click_60_01_02_25', // 点击 批量工具-进校语音电话
  release_member: 'click_60_01_02_26', // 点击 批量工具-释放学员
  award_list_tool: 'click_60_01_02_27', // 点击 批量工具-榜单工具
  lesson_watching_link: 'click_60_01_02_28', // 点击 批量工具-lesson_watching_link
  student_wechat_patch_remark: 'click_60_01_02_29', // 点击 批量工具-批量微信备注
  mass_group_message: 'click_60_01_02_30', // 点击 批量工具-群发群消息
  group_wcw: 'click_60_01_02_31' // 点击 批量工具-群发企微消息
};
/** 单体工具点击点位 */
export const singleToolLog = {
  student_wechat_name_remark: 'click_60_01_02_02', // 微信备注
  mistaken_question_book: 'click_60_01_02_16', // 错题重做
  seat_phone: 'click_60_01_02_17', // 坐席电话
  phone: 'click_60_01_02_15', // 电话
  friend_wechat: 'click_60_01_02_18', // 发送加微申请
  stage_report: 'click_60_01_02_19', // 阶段报告
  endclass_report: 'click_60_01_02_20', // 结课报告
  learning_diary: 'click_60_01_02_21', // 学习日记
  diagnosis: 'click_60_01_02_22', // 诊断
  wrong_question_redo_result: 'click_60_01_02_32', // 错题重做情况
  interact_question: 'click_60_01_02_33', // 互动题
  learning_report: 'click_60_01_02_34', // 学习报告
  diagnosis_situation: 'click_60_01_02_35', // 诊断情况
  complete_touch: 'click_60_01_02_36', // 完成触达
  supplement_sms: 'click_60_01_02_37', // 补发短信
  upload_image: 'click_60_01_02_38', // 上传聊天截图-单体工具
  cancel_refound: 'click_60_01_02_39', // 取消退费-单体工具
  confirm_refound: 'click_60_01_02_40', // 确认退费-单体工具
  record_check: 'click_60_01_02_41', // 录音检查-单体工具
  follow_class: 'click_60_01_02_42', // 去跟课
  outbound_call: 'click_60_01_02_43' // 外呼宝
};
/** 学员详情页点位 */
export const detailLog = {
  performance: 'click_60_01_03_06', // tab 课程表现
  info: 'click_60_01_03_07', // tab 学员信息
  buy_record: 'click_60_01_03_08', // tab 购买记录
  touch_record: 'click_60_01_03_09', // tab 沟通记录
  transfer_class_record: 'click_60_01_03_10', // tab 转班记录
  circulation_record: 'click_60_01_03_11', // tab 流转记录
  toolbox: 'click_60_01_03_12', // tab 工具箱
  correction_notebook: 'click_60_01_03_13', // tab 错题本
  phone: 'click_60_01_03_02', // 电话工具
  set_phone: 'click_60_01_03_03', // 坐席电话工具
  communication_record: 'click_60_01_03_04', // 添加沟通记录工具
  wechat_application: 'click_60_01_03_05', // 添加加微申请工具
  edit_student_tag: 'click_60_01_03_14', // 编辑标签

  toggle_stu: 'click_60_01_03_31', //	详情页-切换学员
  refresh: 'click_60_01_03_32', //	详情页-刷新按钮
  detail_close: 'click_60_01_03_33', //	详情页-关闭按钮
  student_info_update: 'click_60_01_03_34', //	详情页-学员信息-信息修改
  student_info_show: 'click_60_01_03_35', //	详情页-学员信息-学习情况展开
  student_info_fold: 'click_60_01_03_36', //	详情页-学员信息-学习情况收起
  buy_record_filter: 'click_60_01_03_37', //	详情页-购买记录筛选
  correction_notebook_filter: 'click_60_01_03_38', //	详情页-错题本筛选
  listen: 'click_60_01_03_15', // 课程表现-听课情况
  answer: 'click_60_01_03_16', // 课程表现-互动答题'
  homework: 'click_60_01_03_17', // 课程表现-课堂巩固
  copy_image: 'click_60_01_03_18', // 课程表现-复制图片
  typing: 'click_60_01_03_19', // 沟通记录-手动录入
  call: 'click_60_01_03_20', // 沟通记录-电话
  message: 'click_60_01_03_21', // 沟通记录-短信
  tts: 'click_60_01_03_22', // 沟通记录-tts
  tts_view: 'click_60_01_03_23', // 沟通记录-tts-查看
  call_replay: 'click_60_01_03_30', // 沟通记录-电话-播放
  litigation: 'click_60_01_03_24', // 工具箱-客诉服务
  authorize: 'click_60_01_03_25', // 工具箱-授权服务
  logistics: 'click_60_01_03_26', // 工具箱-物流查询
  scholarship: 'click_60_01_03_27', // 工具箱-发奖学金
  export: 'click_60_01_03_29' // 错题本-导出错题
};
/** 导航栏点位 */
export const navigateLog = {
  search: 'click_60_01_05_02', // 搜索
  completeLesson: 'click_60_01_05_03', // 开课结课
  completeLessonCancel: 'click_60_01_05_04', // 取消-开课结课
  completeLessonConfirm: 'click_60_01_05_05' // 结课-开课结课
};
/** 表格内点位 */
export const tableLog = {
  sort: 'click_60_01_04_02', // 表头-排序
  search: 'click_60_01_04_03', // 表头-搜索
  checkboxSearch: 'click_60_01_04_04', // 表头-多选筛选
  rangeSearch: 'click_60_01_04_05', // 表头-范围筛选
  timeSearch: 'click_60_01_04_06', // 表头-时间筛选
  FilteringModeCheck: 'click_60_01_04_31', // 表头-筛选类型-多选组合
  radioEdit: 'click_60_01_04_07', // 表格内-单选编辑
  textareaEdit: 'click_60_01_04_08', // 表格内-文本编辑
  checkboxEdit: 'click_60_01_04_10', // 表格内-多选编辑
  tagEdit: 'click_60_01_04_09', // 表格内-编辑标签/默认编辑
  link: 'click_60_01_04_11', // link点击
  click_60_01_04_12: 'click_60_01_04_12', //	清除筛选
  click_60_01_04_13: 'click_60_01_04_13', //	自定义表头
  click_60_01_04_14: 'click_60_01_04_14', //	自定义表头-重置
  click_60_01_04_15: 'click_60_01_04_15', //	自定义表头-确定
  click_60_01_04_16: 'click_60_01_04_16', //	自定义表头-关闭/取消
  click_60_01_04_17: 'click_60_01_04_17', //	刷新
  click_60_01_04_18: 'click_60_01_04_18', //	展开/收起操作列
  click_60_01_04_19: 'click_60_01_04_19', //	错题重做-弹窗关闭
  click_60_01_04_20: 'click_60_01_04_20', //	是否好友且绑定-弹窗关闭
  click_60_01_04_21: 'click_60_01_04_21', //	表格内编辑-关闭
  click_60_01_04_22: 'click_60_01_04_22', //	自定义标签-添加
  click_60_01_04_23: 'click_60_01_04_23', //	自定义标签-关闭
  click_60_01_04_24: 'click_60_01_04_24', //	沟通记录-关闭
  click_60_01_04_25: 'click_60_01_04_25', //	未续报原因-关闭
  click_60_01_04_26: 'click_60_01_04_26', //	诊断情况-关闭
  click_60_01_04_27: 'click_60_01_04_27', // 表格-切换每页条数
  click_60_01_04_28: 'click_60_01_04_28', // 表格-checkModalTree-重置
  click_60_01_04_29: 'click_60_01_04_29', // 表格-批量工具-下拉
  click_60_01_04_30: 'click_60_01_04_30', // 表格-单体工具-省略号
  click_60_01_04_32: 'click_60_01_04_32', // 表头-checkModal-确定
  click_60_01_04_33: 'click_60_01_04_33', // 表头-checkModal-取消
  click_60_01_04_34: 'click_60_01_04_34', // 表头-checkModal-重置
  click_60_01_04_35: 'click_60_01_04_35' // 表头-checkModal-全选
};

export const inLog = 'refresh_60_01_07_22'; //	曝光
export const globalLog = {
  mouseMove: 'launch_60_01_12_02',
  bodyClick: 'click_60_01_12_03',
  doubleClick: 'click_60_01_12_04',
  rightClick: 'click_60_01_12_05',
  copy: 'click_60_01_12_06'
};
